var map = {
	"./tipocontacto01.svg": 1425,
	"./tipocontacto010.svg": 1426,
	"./tipocontacto011.svg": 1427,
	"./tipocontacto012.svg": 1428,
	"./tipocontacto02.svg": 1429,
	"./tipocontacto03.svg": 1430,
	"./tipocontacto04.svg": 1431,
	"./tipocontacto05.svg": 1432,
	"./tipocontacto06.svg": 1433,
	"./tipocontacto07.svg": 1434,
	"./tipocontacto08.svg": 1435,
	"./tipocontacto09.svg": 1436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;